// extracted by mini-css-extract-plugin
export var col = "index-module--col--sN6Jd";
export var col1 = "index-module--col1--los8B index-module--col--sN6Jd";
export var cols = "index-module--cols--9U-YX flex";
export var fullWidth = "index-module--fullWidth--XCyym index-module--fullWidth--jvj2O util-module--fullWidth--iiqEb util-module--brush--6CByv";
export var mqMaxMd = "screen and (max-width: 48em)";
export var mqMinMd = "screen and (min-width: 48em)";
export var screenshot = "index-module--screenshot--csTgG";
export var sec0 = "index-module--sec0--7jbD2 section";
export var sec1 = "index-module--sec1--b6nox flex";
export var sec1Header = "index-module--sec1Header--atnm9";